import { useEffect, useState } from "react";
import { Loader2, ScrollText } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { AdminShell } from "./AdminShell";
import { PageHeader } from "./parts";

const ACTION_LABELS = {
  connexion_admin: "Connexion administrateur",
  create_school: "Création d'école",
  update_school: "Modification d'école",
  create_teacher: "Création d'enseignant",
  create_parent: "Création de parent",
  update_user: "Modification de compte",
  reset_password: "Réinitialisation de mot de passe",
  update_settings: "Modification des paramètres",
};

function actionLabel(a) {
  if (ACTION_LABELS[a]) return ACTION_LABELS[a];
  if (a?.startsWith("user_status_")) return `Statut compte → ${a.replace("user_status_", "")}`;
  if (a?.startsWith("school_status_")) return `Statut école → ${a.replace("school_status_", "")}`;
  return a;
}

function formatDate(iso) {
  try {
    return new Date(iso).toLocaleString("fr-FR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch { return iso; }
}

export default function AdminAudit() {
  const [logs, setLogs] = useState(null);

  useEffect(() => {
    api.get("/admin/audit?limit=200").then((r) => setLogs(r.data)).catch(() => toast.error("Impossible de charger le journal."));
  }, []);

  return (
    <AdminShell>
      <PageHeader title="Journal d'audit" subtitle="Historique des actions d'administration." />
      {logs === null ? (
        <div className="flex justify-center py-24"><Loader2 className="animate-spin text-slate-400" size={28} /></div>
      ) : (
        <div className="overflow-hidden rounded-2xl border border-slate-100 bg-white shadow-[0_4px_20px_rgb(0,0,0,0.03)]" data-testid="audit-table">
          <table className="w-full text-sm">
            <thead className="border-b border-slate-100 bg-slate-50/50 text-left text-xs uppercase tracking-wide text-slate-500">
              <tr><th className="px-5 py-3">Date</th><th className="px-5 py-3">Auteur</th><th className="px-5 py-3">Action</th><th className="px-5 py-3">Cible</th></tr>
            </thead>
            <tbody>
              {logs.map((l) => (
                <tr key={l.id} className="border-b border-slate-50 last:border-0 hover:bg-slate-50/40" data-testid={`audit-row-${l.id}`}>
                  <td className="px-5 py-3.5 whitespace-nowrap text-slate-500">{formatDate(l.created_at)}</td>
                  <td className="px-5 py-3.5 text-slate-700">{l.actor_name || "—"}</td>
                  <td className="px-5 py-3.5 font-medium text-slate-900"><div className="flex items-center gap-2"><ScrollText size={14} className="text-slate-400" />{actionLabel(l.action)}</div></td>
                  <td className="px-5 py-3.5 text-slate-500">{l.target_type || "—"}</td>
                </tr>
              ))}
              {logs.length === 0 && <tr><td colSpan={4} className="px-5 py-16 text-center text-sm text-slate-400">Aucune action enregistrée.</td></tr>}
            </tbody>
          </table>
        </div>
      )}
    </AdminShell>
  );
}
